var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "delivery" },
      [
        _c("h1", { staticClass: "delivery-title" }, [
          _vm._v("\n      Доставка в городе\n      "),
          _c("span", { on: { click: _vm.changeCity } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.cityName || _vm.USER_CITY.name) +
                "\n      "
            )
          ])
        ]),
        _c("ui-tabs", {
          staticClass: "delivery-tabs",
          attrs: { items: _vm.tabs },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }